<template>
  <a-form layout='vertical' @submit.prevent="handleSubmit" :autoFormCreate="(form)=>{this.form = form}">
    <template v-if="form">
      <a-form-item
        label='Организация'
        :validateStatus="companyNameError() ? 'error' : ''"
        :help="companyNameError() || ''"
        fieldDecoratorId="company"
        :fieldDecoratorOptions="{rules: [{ required: true, message: 'Пожалуйста, введите название организации!' }]}"
      >
        <a-input placeholder='Введите название организации' >
          <a-icon slot="prefix" type='home' style="color:rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>

      <a-form-item
        label='Пароль'
        :validateStatus="passwordError() ? 'error' : ''"
        :help="passwordError() || ''"
        fieldDecoratorId="password"
        :fieldDecoratorOptions="{rules: [{ required: true, message: 'Пожалуйста, введите пароль!' }]}"
      >
        <a-input type='password' placeholder='Введите пароль'>
          <a-icon slot="prefix" type='lock' style="color:rgba(0,0,0,.25)"/>
        </a-input>
      </a-form-item>


      <a-form-item>
        <a-button
          type='primary'
          htmlType='submit'
          :disabled="hasErrors(form.getFieldsError())"
        >
          Войти
        </a-button>

      </a-form-item>
    </template>
  </a-form>
</template>

<script>
// import {a-form, a-form-item, a-input, a-icon} from 'ant-design-vue';
function hasErrors (fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}
export default {
  data () {
    return {
      hasErrors,
      form: null,
    }
  },
  mounted () {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields()
    })
  },
  methods: {
    // Only show error after a field is touched.
    companyNameError () {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('company') && getFieldError('company')
    },
    // Only show error after a field is touched.
    passwordError () {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('password') && getFieldError('password')
    },
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const d = {
            ...values,
            // company: "123",
            login: "Bran",
            // pass: "789"
          }

          this.$store.dispatch('login', d)
            .then((r) => {
              let maxAge = new Date()
              maxAge.setTime(maxAge.getTime() + (60*20000))

              this.$cookies.set("cv_lk", "313", maxAge,  this.$store.state.endpoint);

              return r
            })
            .catch(() => {
              this.$message.error("Ошибка при входе")
            })
        }
      })
    },
  },
}
</script>